import { post } from "../config";

export function GetBankAccounts(body = {}) {
  return post({ url: `/api/aunjai/bank`, body });
}
